const caServices = [
    {
        "name": "КНЕДП/АЦСК Національного банку України",
        "id": "nbu"
    },
    {
        "name": "КНЕДП ІДД ДПС",
        "id": "iddDfs"
    },
    {
        "name": "КНЕДП \"Дія\"",
         "id": "yusticiya"
    },
    {
        "name": "КНЕДП/АЦСК ТОВ \"Центр сертифікації ключів \"Україна\"",
        "id": "tovUkraine"
    },
    {
        "name": "КНЕДП/АЦСК АТ КБ \"Приватбанк\"",
        "id": "privat"
    },
    {
        "name": "КНЕДП/АЦСК ПАТ \"УкрСиббанк\"",
        "id": "ukrSibBank"
    },
    {
        "name": "КНЕДП/АЦСК \"MASTERKEY\" ТОВ \"Арт-Мастер\"",
        "id": "masterKey"
    },
    {
        "name": "КНЕДП/АЦСК Збройних Сил",
        "id": "zsu"
    },
    {
        "name": "КНЕДП/АЦСК МВС України",
        "id": "mvsu"
    },
    {
        "name": "КНЕДП Державної прикордонної служби України",
        "id": "dpsu"
    },
    {
        "name": "КНЕДП/АЦСК Укрзалізниці",
        "id": "ukrZal"
    },
    {
        "name": "КНЕДП \"АЦСК ринку електричної енергії\"",
        "id": "rinokEnergy"
    },
    {
        "name": "КНЕДП/АЦСК ТОВ \"КС\"",
        "id": "tovKs"
    },
    {
        "name": "КНЕДП ДП \"УСС\"",
        "id": "uss"
    },
    {
        "name": "КНЕДП органів прокуратури України",
        "id": "gpuProxyPrime"
    },
    {
        "name": "КНЕДП/АЦСК АТ \"Ощадбанк\"",
        "id": "oschad"
    },
    {
        "name": "КНЕДП \"Казначейство\"",
        "id": "caKaznach"
    },
    {
        "name": "КНЕДП ТОВ \"Депозит Сайн\"",
        "id": "depositsign"
    },
    {
        "name": "КНЕДП ПАТ \"Альфа-Банк\"",
        "id": "alfabank"
    },
    {
        "name": "КНЕДП АТ \"КРЕДІ АГРІКОЛЬ БАНК\"",
        "id": "creditagricole"
    },
    {
        "name": "Тестовий ЦСК Сайфер",
        "id": "testCipherCa"
    },
    {
         "name": "Тестовий ЦСК Сайфер (проксі)",
         "id": "testCipherCaProxy"
    },
    {
         "name": "Тестовий ЦСК ІІТ",
         "id": "testIitCa"
    }
];

export default caServices;